import { Page } from '@/components';
import MarketParamsTable from './MarketParamsTable';
import ParamsChangesTable from './ParamsChangesTable';
import IRMParamsTable from './IRMParamsTable';
import EmodeParamsTable from './EmodeParamsTable';

export default function MarketParametersPage() {
  return (
    <Page title="Parameters">
      <ParamsChangesTable />
      <MarketParamsTable />
      <EmodeParamsTable />
      <IRMParamsTable />
    </Page>
  );
}
